import { render, staticRenderFns } from "./promocion.consultar.vue?vue&type=template&id=7f4ff63f&scoped=true&"
import script from "./promocion.consultar.vue?vue&type=script&lang=js&"
export * from "./promocion.consultar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4ff63f",
  null
  
)

export default component.exports